module.exports = __webpack_public_path__ + "static/media/landing_bg.0e2ae4de.png";